<template>
    <div>
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t('auto.stringFormatterReplaceFindPattern') }}</div>
            <TiptapEditor
                placeholder="Enter the pattern to find"
                :show-attributes="true"
                v-model="clone.replace.pattern"
                :show-emoji="false"
                automation-mode
            />
            <small class="description">{{ $t('auto.stringFormatterReplaceEnterTheRegularExpressionOrTextToSearchFor') }}</small>
        </div>

        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t('auto.stringFormatterReplaceReplaceWith') }}</div>
            <TiptapEditor
                placeholder="Enter the replacement text"
                :show-attributes="true"
                v-model="clone.replace.replacement"
                :show-emoji="false"
                automation-mode
            />
            <small class="description">{{ $t('auto.stringFormatterReplaceEnterTheTextThatWillReplaceTheFoundPattern') }}</small>
        </div>

        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t('auto.stringFormatterReplaceFlags') }}</div>
            <TiptapEditor
                placeholder="Regular expression flags (e.g. 'g' for global, 'i' for case insensitive)"
                :show-attributes="true"
                v-model="clone.replace.flags"
                :show-emoji="false"
                automation-mode
            />
            <small class="description">{{ $t('auto.stringFormatterReplaceOptionalRegexFlagsGGlobalICaseInsensitiveMMultilineEtc') }}</small>
        </div>

        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t('auto.stringFormatterReplaceReplaceAllOccurrences') }}</div>
            <a-switch v-model="clone.replace.all" />
            <small class="description">{{ $t('auto.stringFormatterReplaceWhenEnabledAllOccurrencesWillBeReplaced') }}</small>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";

const log = log2("StringFormatterReplace");
export default {
    name: "StringFormatterReplace",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "string.replace",
            value: "",
            replace: {
                pattern: "",
                replacement: "",
                flags: "",
                all: true,
            }
        };
        return {
            clone,
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        value(newValue) {
            if (_.isEqual(newValue, this.clone)) return;
            this.clone = _.cloneDeep(newValue);
        },
    },
};
</script>

<style lang="scss" scoped>
.editor-row {
    width: 100%;

    &.customize-editor-minimize {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    small.description {
        font-size: 10px;
        color: var(--color-text-weak-default);
    }

    .editor-row-title {
        font-weight: bold;
        font-size: 16px;
    }
}
</style> 